const getEnabledKYC = (kyc) => { var _a; return (_a = kyc === null || kyc === void 0 ? void 0 : kyc.filter(({ enabled }) => Boolean(enabled))) !== null && _a !== void 0 ? _a : []; };

export { getEnabledKYC };
